export default {
  tips: [
    "Keep your API key confidential: Your API keys act like passwords. Never share them with others or send them via email or public messages.",
    "Use secure environments: Only use API keys in secure and trusted environments. Avoid placing them in public source code or GitHub repositories.",
    "Monitor activities: Regularly review activities associated with your API keys. If you notice suspicious activity, immediately deactivate your key.",
    "Security reminder: Your keys expire every 7 days. You must request new keys regularly."
  ],
  documentation: "API Documentation",
  footer:
    "These tips will help you secure your account and prevent possible misuse."
};
